// extracted by mini-css-extract-plugin
export default {"title":"_9a2b0862"};